var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  var bindingsFromString = function(bindingString) {
    try {
      var result = parseV2Format();
      if(typeof result === 'object'){
        return result;
      }
      return parseV1Format();
    }
    catch (ex) {
      return parseV1Format();
    }

    function parseV1Format() {
      return bindingString.split("|").map(function(b){
        var bindingParts = b.split("/");
        var bindingInfo = bindingParts[1].split(":");
        var enabled = bindingParts.length >= 4 ? (bindingParts[3] === "True") : true;
        var requireSni = bindingParts.length >= 5 ? (bindingParts[4] === "True"): false;
        return {
          protocol: bindingParts[0],
          enabled: enabled,
          thumbprint: bindingParts[2],
          ipAddress: bindingInfo[0],
          port: bindingInfo[1],
          host: bindingInfo[2],
          requireSni: requireSni
        };
      });
    }

    function parseV2Format() {
      return JSON.parse(bindingString);
    }
  };

  var bindingsToString = function(bindings) {
    var result = bindings.map(function(b) {
      var isHttp = (b.protocol === "http");
      //strip http etc except inside #{...} variable declarations
      b.host = b.host
        .split(/(#{.*?})/g)
        .map(function(h){
           return /^#{.*}$/.test(h)
            ? h
            : h.replace("//", "").replace("/", "").replace("https:", "").replace("http:", "");
        })
        .join("");

      return {
        protocol: b.protocol,
        ipAddress:  b.ipAddress,
        port: b.port,
        host: b.host,
        thumbprint: isHttp ? "" : b.thumbprint,
        requireSni: isHttp ? false : b.requireSni,
        enabled: b.enabled
      };
    });

    return JSON.stringify(result);
  };

  pluginRegistry.registerFeature("Octopus.Features.IISWebSite", function(busy, octopusRepository, $uibModal, $rootScope, sensitiveValue) {
    return {
      title: "IIS web site and application pool",
      description: "Creates or reconfigures an IIS website and application pool (requires IIS7+)",
      editTemplateUrl: "areas/projects/features/Octopus.Features.IISWebSite_edit.html",
      priority: 8,
      editLink: function($scope, element, action, step, project) {

        if (!action.Properties["Octopus.Action.IISWebSite.DeploymentType"]) {
          action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = 'webSite';
        }

        $scope.isIISStep = action.ActionType === "Octopus.IIS";

        $scope.$watch("action.Properties.Octopus.Action.IISWebSite.Bindings", function() {
          $scope.iisBindings = bindingsFromString(action.Properties["Octopus.Action.IISWebSite.Bindings"]);
        });

        $scope.removeBinding = function(b) {
          $scope.iisBindings.splice($scope.iisBindings.indexOf(b), 1);
          action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
        };

        $scope.editBinding = function(binding) {
          $uibModal.open({
            size: "lg",
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html',
            controller: "IISWebSiteDialogController",
            resolve: {
              "projectId" : function() {
                return project.Id;
              },
              "binding": function () {
                return _.clone(binding);
              }
            }
          }).result.then(function(result) {
            if (result) {
              var ix = $scope.iisBindings.indexOf(binding);
              $scope.iisBindings[ix] = result;
              action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
            }
          });
        };

        $scope.addBinding = function() {
          $uibModal.open({
            size: "lg",
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/projects/features/Octopus.Features.IISWebSite_binding_dialog.html',
            controller: "IISWebSiteDialogController",
            resolve: {
              "projectId" : function() {
                return project.Id;
              },
              "binding": function() {
                return {
                  protocol: "http",
                  port: "80",
                  ipAddress: "*",
                  host: "",
                  thumbprint: "",
                  enabled: true,
                  requireSni: false
                };
              }
            }
          }).result.then(function(result) {
            if (result) {
              $scope.iisBindings.push(result);
              action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString($scope.iisBindings);
            }
          });
        };

        $scope.selectVirtualDirectory = function () {
          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'True';
          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'False';
        };

        $scope.selectWebSite = function () {
          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'True';
        };

        $scope.selectWebApplication = function () {
          action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.CreateOrUpdate"] = 'False';
          action.Properties["Octopus.Action.IISWebSite.WebApplication.CreateOrUpdate"] = 'True';
          action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = 'False';
        };

        $scope.checkWebSiteName = function() {
          var name = action.Properties["Octopus.Action.IISWebSite.WebSiteName"];
          $scope.looksLikeVDir = name && (name.indexOf('/') !== -1 || name.indexOf('\\') !== -1);
        };

        $scope.checkWebRoot = function() {
          var path = action.Properties["Octopus.Action.IISWebSite.WebRoot"];
          $scope.looksLikeFullPath = path && path.indexOf(':') !== -1;
        };
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = 'webSite';
        action.Properties["Octopus.Action.IISWebSite.CreateOrUpdateWebSite"] = "True";

        action.Properties["Octopus.Action.IISWebSite.Bindings"] = bindingsToString([{ protocol: "http", port: 80, host: "", enabled: true }]);
        setupApplicationPoolDefaults(action, "Octopus.Action.IISWebSite");

        action.Properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] = "False";
        action.Properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] = "False";
        action.Properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] = "True";

        setupApplicationPoolDefaults(action, "Octopus.Action.IISWebSite.WebApplication");

        function setupApplicationPoolDefaults(action, pathToRootProperty) {
          action.Properties[pathToRootProperty + ".ApplicationPoolFrameworkVersion"] = "v4.0";
          action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"] = "ApplicationPoolIdentity";
        }
      },
      preSave: function(action, step) {
        normalizeApplicationPoolData(action, "Octopus.Action.IISWebSite");
        normalizeApplicationPoolData(action, "Octopus.Action.IISWebSite.WebApplication");

        function normalizeApplicationPoolData(action, pathToRootProperty) {
          if(action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"] !== "SpecificUser" && !$rootScope.isBound(action.Properties[pathToRootProperty + ".ApplicationPoolIdentityType"])) {
            action.Properties[pathToRootProperty + ".ApplicationPoolUsername"] = null;
            action.Properties[pathToRootProperty + ".ApplicationPoolPassword"]  = null;
          }
        }
      },
      validate: function(action, step, errors) {
        var deploymentType = action.Properties["Octopus.Action.IISWebSite.DeploymentType"];
        if(!deploymentType) {
            deploymentType = (action.Properties["Octopus.Action.IISWebSite.DeploymentType"] = "webSite");
        }
        switch(deploymentType) {
          case "webSite" :
            if (!action.Properties["Octopus.Action.IISWebSite.Bindings"]) {
              errors.push("Please add at least one IIS binding.");
            }
            if (!action.Properties["Octopus.Action.IISWebSite.WebSiteName"]) {
              errors.push("Please enter an IIS web site name");
            }
            if (!action.Properties["Octopus.Action.IISWebSite.ApplicationPoolName"]) {
              errors.push("Please enter an IIS application pool name");
            }
            if (action.Properties["Octopus.Action.IISWebSite.EnableAnonymousAuthentication"] + action.Properties["Octopus.Action.IISWebSite.EnableBasicAuthentication"] + action.Properties["Octopus.Action.IISWebSite.EnableWindowsAuthentication"] === "FalseFalseFalse") {
              errors.push("Please enable at least one of the IIS authentication options");
            }
            break;
          case "webApplication":
            if (!action.Properties["Octopus.Action.IISWebSite.WebApplication.WebSiteName"]) {
              errors.push("Please enter an IIS web site name");
            }
            if (!action.Properties["Octopus.Action.IISWebSite.WebApplication.VirtualPath"]) {
              errors.push("Please enter an IIS virtual path");
            }
            if (!action.Properties["Octopus.Action.IISWebSite.WebApplication.ApplicationPoolName"]) {
              errors.push("Please enter an IIS application pool name");
            }
            break;
          case "virtualDirectory":
            if (!action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.WebSiteName"]) {
              errors.push("Please enter an IIS web site name");
            }
            if (!action.Properties["Octopus.Action.IISWebSite.VirtualDirectory.VirtualPath"]) {
              errors.push("Please enter an IIS virtual path");
            }
            break;
          default:
            throw  "Unknown deployment type: " + deploymentType;
        }
      },
      disable: function(action, step) {
        Object.keys(action.Properties).filter(function(name) {
          return name.indexOf("Octopus.Action.IISWebSite.") === 0;
        }).forEach(function(name){
          delete action.Properties[name];
        });
      }
    };
  });
});

module.controller('IISWebSiteDialogController', function ($scope, busy, octopusRepository, pluginRegistry, $uibModalInstance, projectId, binding) {
  $scope.isSaving = busy.create();

  $scope.binding = binding;
  binding.projectId = projectId;

  $scope.protocolChanged = function() {
    if ($scope.binding.protocol === "https") {
      $scope.binding.port = "443";
    }
  };

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.save = function () {
    if ($scope.binding.protocol === 'https') {
      if ($scope.binding.thumbprint.trim() === '') {
        $scope.isSaving.showError('An SSL certificate thumbprint must be provided for HTTPS bindings.');
        return;
      }

      if (!$scope.isBound($scope.binding.thumbprint)) {
        $scope.binding.thumbprint = $scope.binding.thumbprint.replace(/[^0-9A-z]/g, '');
      }
    }

    $uibModalInstance.close($scope.binding);
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.IISWebSite.js
// module id = 560
// module chunks = 1